export default __webpack_public_path__ + "images/1d87d01c25d690d5564dd4184cd39f8e-science.webp";